export default __webpack_public_path__ + "static/media/doc1.3eabf0d9.png";